/**
 * 剪贴板复制辅助（从 Dashboard 拆出）
 */

export function fallbackCopyToClipboard(text, options = {}) {
  const {
    successMessage = '坐标已复制到剪贴板',
    failMessage = '复制失败，请手动复制坐标'
  } = options;
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    if (successMessage) alert(successMessage);
    return true;
  } catch (err) {
    console.error('备用复制方法失败:', err);
    if (failMessage) alert(failMessage);
    return false;
  }
}

export function copyToClipboard(text, options = {}) {
  const {
    successMessage = '坐标已复制到剪贴板',
    failMessage = '复制失败，请手动复制坐标'
  } = options;

  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).then(() => {
      if (successMessage) alert(successMessage);
    }).catch((err) => {
      console.error('复制坐标失败:', err);
      fallbackCopyToClipboard(text, { successMessage, failMessage });
    });
  }
  fallbackCopyToClipboard(text, { successMessage, failMessage });
  return Promise.resolve();
}
